export default "__VITE_ASSET__9r1HfVbe__"